import {
  Modal,
  Row,
  Table,
} from "antd";
import React from "react";
import "./style.css";

// const dateFormat = "DD/MM/YYYY";

const ModalCheckCV = ({
  isModalOpenCheckCV,
  dataCheckCV,
  handleCancelCheckCV,
  columns
}) => {
  return (
    <Modal
      title={`Danh sách hồ sơ trùng lặp (${dataCheckCV.code_cv})`}
      open={isModalOpenCheckCV}
      onCancel={() => {
        handleCancelCheckCV();
      }}
      width={"60%"}
      footer={false}
      className={"resize-form"}
    >
        <Row className="modal-edit-candidate-row">
          <Table
            className="cadidate-management-table"
            columns={columns}
            dataSource={dataCheckCV.data_duplicate.results}
            pagination={false}
            scroll={{
              x: "max-content", // Kích thước ngang tự động điều chỉnh theo nội dung cột
              y: 550, // Chiều cao tối đa có thể lăn (thay số này để phù hợp với màn hình)
            }}
          />
        </Row>
    </Modal>
  );
};

export default ModalCheckCV;
